import { JSONType } from "Typings/Global";
import { User, UserComment } from './@types';

export const userParser = (data: JSONType): User => {
    const {
        id, firstName, lastName, email, name, _profileImage, phone, roles, designation, isPublished
    } = data;
    return {
        id, firstName, lastName, email, name, _profileImage, phone, roles, isBanned: isPublished, designation
    }
}

export const userToRequestDataMapping =(data: Partial<User>) =>{
    const {id,firstName, lastName, email, name, _profileImage, phone, roles, isBanned, designation } = data;
    return{
        id, firstName, lastName, email, name, _profileImage, phone, roles, isPublished: isBanned, designation
    }
}

export const userCommentsParser =(data: JSONType): UserComment =>{
    const {body, created, entityId, id, isPublished, updated, userId} = data;
    return{
        body, created, entityId, id, isPublished, updated, userId
    }
}